
const Projects = () => {
    return (
        <div>Indexing through my projects...</div>
    )
}

export default Projects;